import { CLAUSE_CAMPAIGNS_STORAGE_KEY } from '../stores/clause-campaigns.atom';

export const getClauseCampaigns = () => {
  const token = localStorage.getItem(CLAUSE_CAMPAIGNS_STORAGE_KEY);

  if (!token) {
    return [];
  }

  return JSON.parse(token) as string[];
};

export default getClauseCampaigns;
